import { messagesEN } from './lib/intl/en-US';
import { messagesFR } from './lib/intl/fr-CA';
import { Options } from '@sheerid/jslib';
import { RecursivePartial } from './lib/types/types';

export const programId = '5f986ad14d681618feec32a2';

export const defaultOptions: RecursivePartial<Options> = {
    restApi: {
        serviceUrl: 'https://services.sheerid.com/',
    },
    logLevel: 'error',
    useFingerprinting: true,
    messagesWithLocale: {
        'en-US': messagesEN,
        'fr-CA': messagesFR,
    },
};
